import { useTheme } from '../hooks/useTheme'
import whiteLogo from '../assets/white-logo.png'
import darkLogo from '../assets/dark-logo.png'
import whiteLogoWebp from '../assets/white-logo.webp'
import darkLogoWebp from '../assets/dark-logo.webp'

interface LogoProps {
  className?: string
  variant?: 'light' | 'dark' | 'auto'
}

const Logo = ({ className = "h-8", variant = 'auto' }: LogoProps) => {
  const { theme } = useTheme()

  // Determine which logo to use
  let logoSrc: string
  let logoWebpSrc: string

  if (variant === 'light') {
    logoSrc = whiteLogo
    logoWebpSrc = whiteLogoWebp
  } else if (variant === 'dark') {
    logoSrc = darkLogo
    logoWebpSrc = darkLogoWebp
  } else {
    // auto - use theme
    logoSrc = theme === 'dark' ? whiteLogo : darkLogo
    logoWebpSrc = theme === 'dark' ? whiteLogoWebp : darkLogoWebp
  }

  return (
    <picture>
      <source srcSet={logoWebpSrc} type="image/webp" />
      <img
        src={logoSrc}
        alt="Demirix Logo"
        title="Demirix - Digital Solutions & Technology Services"
        width="160"
        height="32"
        className={`${className} w-auto object-contain`}
      />
    </picture>
  )
}

export default Logo